const SERVICE = {
  id: 'P2DFH3S',
  name: 'shopping cart',
  description: 'Your first service - describe what this service is monitoring and any information that will help responders.\n\nFor example: What is the SLA of this service? Where are the runbooks for this service stored? What tier level is this service?',
  created_at: '2020-05-08T14:09:32Z',
  updated_at: '2020-05-08T14:09:32Z',
  status: 'active',
  teams: [],
  alert_creation: 'create_alerts_and_incidents',
  addons: [],
  scheduled_actions: [],
  support_hours: null,
  last_incident_timestamp: null,
  escalation_policy: {
    id: 'PY44APW',
    type: 'escalation_policy_reference',
    summary: 'Default',
    self: 'https://api.pagerduty.com/escalation_policies/PY44APW',
    html_url: 'https://jemmrich-trial-2.pagerduty.com/escalation_policies/PY44APW'
  },
  incident_urgency_rule: {
    type: 'constant',
    urgency: 'high'
  },
  acknowledgement_timeout: null,
  auto_resolve_timeout: null,
  alert_grouping: null,
  alert_grouping_timeout: null,
  integrations: [],
  response_play: null,
  type: 'service',
  summary: 'shopping cart',
  self: 'https://api.pagerduty.com/services/P2DFH3S',
  html_url: 'https://jemmrich-trial-2.pagerduty.com/service-directory/P2DFH3S'
};

const WITH_NO_SERVICES = {
  services: [],
  limit: 25,
  offset: 0,
  total: null,
  more: false
};

const WITH_SERVICES = {
  ...WITH_NO_SERVICES,
  services: [
    {
      ...SERVICE
    }
  ],
  total: 1
};

const WITH_INTEGRATION = {
  ...WITH_NO_SERVICES,
  services: [
    {
      ...SERVICE,
      integrations: [
        {
          html_url: 'https://pdt-somesubdomain.pd-staging.com/services/PDJGOFM/integrations/P15V5M1',
          id: 'P15V5M1',
          self: 'https://api.pd-staging.com/services/PDJGOFM/integrations/P15V5M1',
          summary: 'Test',
          type: 'generic_email_inbound_integration_reference',
        }
      ],
    }
  ],
  total: 1
};

const POST_RESPONSE = serviceName => ({
  service: {
    ...SERVICE,
    name: serviceName
  }
});

export default {
  WITH_NO_SERVICES,
  WITH_SERVICES,
  WITH_INTEGRATION,
  POST_RESPONSE,
};
